import React from 'react';
import LegalPage from './LegalPage';

export default function TermsPage() {
  return (
    <LegalPage title="Terms of Service" lastUpdated="28 February 2026">
      <section>
        <h2>The agreement</h2>
        <p>
          By creating a Rental P.A. account or using the service you agree to
          these terms. If you don't agree, please don't use the service.
        </p>
      </section>

      <section>
        <h2>What Rental P.A. does (and doesn't do)</h2>
        <p>
          Rental P.A. helps UK landlords store property documents, track
          compliance expiry dates, and remind themselves about renewals. We
          provide tools and reminders, but{' '}
          <strong>
            we do not give legal, tax, or financial advice
          </strong>
          . You are responsible for actually meeting your obligations as a
          landlord — including Gas Safety checks, EICR inspections, EPC
          ratings, deposit protection deadlines, How to Rent Guide service,
          smoke and CO alarm checks, and any other statutory duty in your
          jurisdiction.
        </p>
      </section>

      <section>
        <h2>Your account</h2>
        <ul>
          <li>You must be at least 18 years old.</li>
          <li>You must keep your password secure. You're responsible for activity under your account.</li>
          <li>One person per account. Don't share login credentials.</li>
        </ul>
      </section>

      <section>
        <h2>Your content</h2>
        <p>
          You retain ownership of every document, property record, and tenant
          detail you upload. By uploading, you grant us a limited licence to
          store and process that content solely so we can deliver the service to
          you (e.g. show it back to you in the app, run AI extraction on it,
          include it in your weekly digest).
        </p>
        <p>
          You promise that you have the right to upload anything you upload —
          this is especially important for tenancy agreements that contain
          personal data about your tenants. If your tenant asks you to remove
          their data, please do so promptly.
        </p>
      </section>

      <section>
        <h2>Acceptable use</h2>
        <p>Please don't use Rental P.A. to:</p>
        <ul>
          <li>Send spam, harassing messages, or phishing attempts to tenants or anyone else through the tenant-email feature.</li>
          <li>Upload malware, viruses, or anything that would damage our systems or other users.</li>
          <li>Scrape, reverse engineer, or attempt to gain unauthorised access to the service.</li>
          <li>Resell access to the platform without our written permission.</li>
        </ul>
      </section>

      <section>
        <h2>AI extraction caveat</h2>
        <p>
          We use Google's Gemini model to read documents you upload. AI gets
          things wrong sometimes — please always verify the extracted dates and
          amounts before relying on them. We are not liable for missed renewals
          caused by AI mis-extraction. Treat the AI as an assistant, not the
          source of truth.
        </p>
      </section>

      <section>
        <h2>Reminders are best-effort</h2>
        <p>
          Email and dashboard reminders are provided on a best-effort basis. We
          do our best to send them on time, but email delivery depends on third
          parties (Resend, your email provider, spam filters, etc.). You
          shouldn't rely on reminders alone — keep your own backup system for
          critical deadlines.
        </p>
      </section>

      <section>
        <h2>Pricing &amp; trials</h2>
        <p>
          The Free plan is free forever for one property. Pro and Max plans are
          billed monthly or annually as shown on the pricing page. You can
          cancel any time from your dashboard; cancellation takes effect at the
          end of the current billing period.
        </p>
      </section>

      <section>
        <h2>Termination</h2>
        <p>
          You can delete your account at any time from the dashboard. We can
          suspend or terminate accounts that violate these terms or that pose a
          security risk.
        </p>
      </section>

      <section>
        <h2>Liability</h2>
        <p>
          To the maximum extent permitted by UK law, Rental P.A. is provided
          "as is" and our liability is limited to the fees you've paid us in
          the 12 months before the claim. Nothing in these terms excludes
          liability for things UK law doesn't allow us to exclude (e.g. death
          or personal injury caused by our negligence).
        </p>
      </section>

      <section>
        <h2>Changes to these terms</h2>
        <p>
          We may update these terms occasionally. We'll show the new
          "Last updated" date at the top of this page and, for material
          changes, notify you by email.
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          Questions? Email{' '}
          <a href="mailto:hello@rentalpa.app">hello@rentalpa.app</a>.
        </p>
      </section>
    </LegalPage>
  );
}
